/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCombinations } from '../../factoriesAny.js';
export var combinationsDependencies = {
  typedDependencies,
  createCombinations
};